import React from "react";
import { Row, Col, Input, Select, Button, Space, Tag, Switch, Tooltip } from "antd";
import { EnvironmentOutlined, SearchOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { DEFAULT_FEATURES } from "./features";

// Pannello filtri. Ogni controllo è condizionato dal rispettivo feature flag,
// così la vista org può nascondere Organizzazione/mappa senza duplicare il componente.
const DocumentsFilters = ({
  features,
  filters,
  setFilters,
  contentSearch,
  setContentSearch,
  orgOptions,
  onOpenMap,
  mapActive,
  onClearMap,
  cardsPerRow,
  setCardsPerRow,
  showPreview,
  setShowPreview,
  sortBy,
  setSortBy,
}) => {
  const f = { ...DEFAULT_FEATURES, ...(features || {}) };
  const set = (patch) => setFilters((prev) => ({ ...prev, ...patch }));

  return (
    <div style={{ marginBottom: 16, padding: 16, background: "#fafafa", border: "1px solid #f0f0f0", borderRadius: 8 }}>
      <Row gutter={[8, 8]}>
        {f.nameFilter && (
          <Col flex="1 1 200px">
            <Input
              allowClear
              prefix={<SearchOutlined />}
              placeholder="Nome documento"
              value={filters.nome}
              onChange={(e) => set({ nome: e.target.value })}
            />
          </Col>
        )}
        {f.fullText && (
          <Col flex="1 1 200px">
            <Input
              allowClear
              prefix={<SearchOutlined />}
              suffix={
                <Tooltip title="Cerca solo nei documenti HTML (i PDF non sono indicizzati)">
                  <InfoCircleOutlined style={{ color: "#bbb" }} />
                </Tooltip>
              }
              placeholder="Cerca nel contenuto…"
              value={contentSearch}
              onChange={(e) => setContentSearch(e.target.value)}
            />
          </Col>
        )}
        {f.formatFilter && (
          <Col flex="1 1 200px">
            <Select
              style={{ width: "100%" }}
              value={filters.formato}
              onChange={(v) => set({ formato: v })}
              options={[
                { value: "all", label: "Tutti i formati" },
                { value: "pdf", label: "PDF" },
                { value: "html", label: "HTML" },
              ]}
            />
          </Col>
        )}
        {f.orgFilter && (
          <Col flex="1 1 200px">
            <Select
              allowClear
              showSearch
              optionFilterProp="label"
              style={{ width: "100%" }}
              placeholder="Organizzazione"
              value={filters.org}
              onChange={(v) => set({ org: v || null })}
              options={orgOptions}
            />
          </Col>
        )}
        {f.map && (
          <Col flex="1 1 200px">
            <Button block type={mapActive ? "primary" : "default"} icon={<EnvironmentOutlined />} onClick={onOpenMap}>
              Filtra per posizione
            </Button>
          </Col>
        )}
      </Row>

      <Row justify="space-between" align="middle" style={{ marginTop: 12 }}>
        <Col>
          {f.map && mapActive && (
            <Tag color="blue" closable onClose={onClearMap}>
              Filtro per posizione attivo
            </Tag>
          )}
        </Col>
        <Col>
          <Space size="large" wrap>
            {f.sort && (
              <Space>
                <span style={{ color: "#888" }}>Ordina:</span>
                <Select
                  value={sortBy}
                  onChange={setSortBy}
                  style={{ width: 150 }}
                  options={[
                    { value: "updated_desc", label: "Più recenti" },
                    { value: "updated_asc", label: "Meno recenti" },
                    { value: "nome_asc", label: "Nome (A-Z)" },
                    { value: "nome_desc", label: "Nome (Z-A)" },
                  ]}
                />
              </Space>
            )}
            {f.preview && (
              <>
                <Space>
                  <span style={{ color: "#888" }}>Anteprime:</span>
                  <Switch size="small" checked={showPreview} onChange={setShowPreview} />
                </Space>
                <Space>
                  <span style={{ color: "#888" }}>Card per riga:</span>
                  <Select
                    value={cardsPerRow}
                    onChange={setCardsPerRow}
                    style={{ width: 80 }}
                    options={[
                      { value: 2, label: "2" },
                      { value: 3, label: "3" },
                      { value: 4, label: "4" },
                      { value: 6, label: "6" },
                    ]}
                  />
                </Space>
              </>
            )}
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default DocumentsFilters;
